
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nl/faq",
      function () {
        return require("private-next-pages/nl/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nl/faq"])
      });
    }
  